<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Nodal Ledger">
      <v-card-actions>
          <router-link :to="{ name: 'nodalView' }">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
      </v-card-actions>
      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-divider class=" my-0 " />
      <v-data-table disable-initial-sort hide-default-footer :items-per-page="-1" :headers="headers" :items="tableData" :search="search" :single-expand="true" show-expand item-key="index">
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Nodal Ledger</v-toolbar-title>
          </v-toolbar>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pb-4 pt-4">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center">
                      Student Name
                    </th>
                    <th class="text-center">
                      Student class
                    </th>
                    <th class="text-center">
                      email
                    </th>
                    <th class="text-center">
                      Enquiry Code
                    </th>
                    <th class="text-center">
                      Franchisee Name
                    </th>
                    <th class="text-center">
                      Fee Type
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center" justify="center">{{ item.paymentOrder.notes.name }}</td>
                    <td align="center" justify="center">{{ item.paymentOrder.notes.class }}</td>
                    <td align="center" justify="center">{{ item.paymentOrder.notes.email }}</td>
                    <td align="center" justify="center">{{ item.paymentOrder.notes.enquiryCode }}</td>
                    <td align="center" justify="center">{{ item.paymentOrder.notes.franchiseeName }}</td>
                    <td align="center" justify="center">{{ item.paymentOrder.notes.type }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
      </v-data-table>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
// import CONSTANTS from '@/utils/constants'

import MaterialCard from '@/components/template/MaterialCard'
import Utils from '@/utils'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import _ from 'lodash'
export default {
  components: { MaterialCard },
  name: 'nodalLedgerList',
  data () {
    return {
      expanded: [],
      isLoading: false,
      companyName: '',
      singleExpand: true,
      inProgress: false,
      search: '',
      franchiseeID: '',
      headers: [
        { text: 'Sr.No', sortable: true, value: 'index' },
        { text: 'Recipt No', sortable: true, value: 'paymentOrder.receiptNo' },
        { text: 'status', value: 'status', sortable: true },
        { text: 'Payment ID', value: 'paymentOrder.paymentID', sortable: true },
        { text: 'Enquiry Code', value: 'paymentOrder.notes.enquiryCode', sortable: true },
        { text: 'Payment Status', value: 'paymentOrder.paymentStatus', sortable: true },
        { text: 'Transfer Amount', value: 'amount', sortable: true },
        { text: 'Installment Amount', value: 'installmentAmount', sortable: true },

        { text: 'Particular', value: 'transactionDescription', sortable: true, width: 500 },
        { text: 'Recipent', value: 'recipient', sortable: true },
        { text: 'Tranfer Status ', value: 'transferStatus', sortable: true },
        { text: 'Tranfer ID ', value: 'transferID', sortable: true },
        { text: 'Payment Mode', value: 'paymentOrder.paymentMode', sortable: true }
      ],
      tableData: []
    }
  },

  async created () {
    await this.onFranchiseeChange()
  },
  watch: {
    franchisee: async function (val) {
      this.companyName = val.companyName
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }

        Utils.helper.openDrawer(this, !this.franchiseeID)
        if (this.franchiseeID) {
          await this.onStart()
        }

        this.inProgress = false
      }
    },
    onStart: async function () {
      if (!this.franchiseeID) {
        return this.$dialog.error({
          text: 'Please select Franchisee',
          title: 'Error'
        })
      }

      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/payment-transfer/${this.franchiseeID}`)
        this.tableData = data
        _.map(this.tableData, (obj, key) => {
          obj.index = key + 1
          obj.paymentOrder.amount = Number(obj.paymentOrder.amount) / 100
          obj.paymentOrder.notes = obj.paymentOrder.notes || {}
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
